export const router = {
  home: {
    en: `/`,
  },
  ir35: {
    en: `/ir35`,
  },
  about: {
    en: `/about-us`,
  },
  "about.awards": {
    en: `/about-us/awards`,
  },
  "about.diversity": {
    en: `/about-us/diversity-and-inclusion`,
  },
  team: {
    en: `/consultants`,
  },
  "team.member": {
    en: `/consultants/[url_slug]`,
  },
  blog: {
    en: `/blog`,
  },
  "blog.item": {
    en: `/blog/[url_slug]`,
  },
  "blog.tag": {
    en: `/blog/tag/[url_slug]`,
  },
  events: {
    en: `/events`,
  },
  "events.item": {
    en: `/events/[url_slug]`,
  },
  "events.tag": {
    en: `/events/tag/[url_slug]`,
  },
  careers: {
    en: `/join-us`,
  },
  "careers.register": {
    en: "/join-us/register",
  },
  "careers.register.complete": {
    en: "/join-us/register/submission-complete",
  },
  contact: {
    en: `/contact-us`,
  },
  "contact.form.complete": {
    en: `/contact-us/submission-complete`,
  },
  "submit-job": {
    en: "/submit-a-job",
  },
  "submit-project": {
    en: "/submit-a-project",
  },
  "form.complete": {
    en: `/submission-complete`,
  },
  "cv-upload-home.form.complete": {
    en: `/cv-upload-home/submission-complete`,
  },
  "form.register": {
    en: `/register`,
  },
  hiring: {
    en: `/hiring-solutions`,
  },
  "hiring.permanent": {
    en: `/hiring-solutions/permanent-recruitment`,
  },
  "hiring.contract": {
    en: `/hiring-solutions/contract-recruitment`,
  },
  service: {
    en: `/service-solutions`,
  },
  specialisms: {
    en: `/specialisms`,
  },
  jobs: {
    en: `/jobs`,
  },
  "jobs.form.complete": {
    en: `/join-us/jobs/application-complete`,
  },
  "jobs.item": {
    en: `/join-us/jobs/[url_slug]`,
  },
  "jobs.specialism": {
    en: `/jobs/#/[url_slug]`,
  },
  "popular.roles": {
    en: "/[url_slug]",
  },
  "policy.impressum": {
    en: `/impressum`,
  },
  "policy.dpn": {
    en: `/data-privacy-notification`,
  },
  "policy.privacy": {
    en: `/privacy-policy`,
  },
  "policy.terms": {
    en: `/terms-and-conditions`,
  },
  "policy.cookies": {
    en: `/cookies-policy`,
  },
  "policy.slavery": {
    en: `/modern-slavery-statement`,
  },
  sitemap: {
    en: "/sitemap",
  },
};
